import { _ as _extends } from '../../_rollupPluginBabelHelpers-c245b26a.js';
import { forwardRef, useContext } from 'react';
import { themed } from '@indeed/ifl-css';
import { focusStyles, disabledStyles } from '../../utils/styled.js';
import createResponsive from '../../utils/createResponsive.js';
import ChevronDown from '@indeed/ifl-icons/ChevronDown';
import { DropdownContext } from './Dropdown.js';
import { DropdownTarget } from './DropdownTarget.js';
import { jsx } from '@emotion/react';
import { TouchTarget } from '../TouchTarget/TouchTarget.js';
import { IconWrapper } from '../IconWrapper/IconWrapper.js';
import { Text } from '../Text/Text.js';
import '@indeed/downshift';
import '../../utils/isFunction.js';
import 'react-fast-compare';
import '../../constants/index.js';
import '@indeed/ihl-use-id';
import '../../utils/warnDeprecation.js';
import '../../utils/warn.js';
import 'classnames';
import '../../utils/mergeRefs.js';
import '../../hooks/useHasFocus.js';

const inputSizes = {
  sm: {
    minBlockSize: "2.25rem",
    paddingBlock: 1
  },
  md: {
    minBlockSize: "2.75rem",
    paddingBlock: 2
  }
};
const getInputMinBlockSize = createResponsive(size => inputSizes[size].minBlockSize);
const getInputPaddingBlock = createResponsive(size => inputSizes[size].paddingBlock);
const StyledDropdownInput = /*#__PURE__*/themed("button", process.env.NODE_ENV === "production" ? {
  styleProps: ["invalid", "size", "disabled"],
  shouldForwardProp: prop => prop !== "size" && prop !== "invalid",
  target: "e10jok4m0"
} : {
  styleProps: ["invalid", "size", "disabled"],
  shouldForwardProp: prop => prop !== "size" && prop !== "invalid",
  target: "e10jok4m0",
  label: "StyledDropdownInput"
})(_ref => {
  let {
    invalid,
    size = "md"
  } = _ref;
  return {
    boxSizing: "border-box",
    position: "relative",
    zIndex: 0,
    display: "flex",
    alignItems: "center",
    inlineSize: "100%",
    minBlockSize: getInputMinBlockSize(size),
    marginBlockStart: 0,
    marginBlockEnd: 0,
    paddingBlockStart: getInputPaddingBlock(size),
    paddingBlockEnd: getInputPaddingBlock(size),
    paddingInlineStart: 3,
    paddingInlineEnd: "40px",
    bg: "background",
    borderRadius: "md",
    border: "1px solid",
    borderColor: invalid ? "border.status.critical.strong" : "border.action",
    fontSize: 3,
    fontFamily: "default",
    fontWeight: "normal",
    letterSpacing: 0,
    lineHeight: "normal",
    outline: "none",
    userSelect: "none",
    transition: _ref2 => {
      let {
        transitions
      } = _ref2;
      return `all ${transitions.default}`;
    },
    "@media (prefers-reduced-motion: reduce)": {
      transition: "none"
    },
    ":hover": {
      borderColor: invalid ? "border.status.critical.strong" : "border.action.hover"
    }
  };
}, focusStyles, disabledStyles, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
const A11yStyledDropdownInput = TouchTarget.withComponent(StyledDropdownInput, process.env.NODE_ENV === "production" ? {
  target: "e10jok4m1"
} : {
  target: "e10jok4m1",
  label: "A11yStyledDropdownInput"
});

/**
 * @deprecated The `Dropdown` component will be removed in IFL 7.
 * See the IFL 7 preparation guide for more information: https://link.indeed.tech/ifl-7-prep-guide
 */

const DropdownInput = /*#__PURE__*/forwardRef((_ref3, ref) => {
  let {
    inlineLabel,
    placeholder,
    renderValue = selectedItems => selectedItems.join(", "),
    size = "md",
    iconBefore,
    ...props
  } = _ref3;
  const {
    disabled,
    invalid,
    selectedItems,
    getLabelProps
  } = useContext(DropdownContext);
  const hasSelected = selectedItems && selectedItems.length > 0;
  return jsx(DropdownTarget, null, jsx(A11yStyledDropdownInput, _extends({
    ref: ref,
    disabled: disabled,
    invalid: invalid,
    "aria-invalid": invalid,
    size: size,
    type: "button"
  }, props), iconBefore && jsx(IconWrapper, {
    sx: {
      marginInlineEnd: 2,
      color: "foreground.weak"
    }
  }, iconBefore), jsx(Text, {
    sx: {
      color: hasSelected ? "foreground.strong" : "foreground.weak",
      whiteSpace: "nowrap",
      textOverflow: "clip",
      overflow: "hidden"
    }
  }, inlineLabel && jsx(Text, _extends({
    variant: "contrast",
    sx: {
      fontWeight: "bold"
    }
  }, getLabelProps()), inlineLabel), hasSelected ? renderValue(selectedItems) : placeholder), jsx(IconWrapper, {
    sx: {
      display: "flex",
      position: "absolute",
      top: "50%",
      right: 3,
      color: "foreground.strong",
      transform: "translateY(-50%)",
      ".is-open &": {
        transform: "translateY(-50%) rotate(180deg)"
      }
    }
  }, jsx(ChevronDown, {
    "aria-hidden": "true"
  }))));
});
DropdownInput.displayName = "DropdownInput";

export { A11yStyledDropdownInput, DropdownInput, StyledDropdownInput };
